<template>
  <div id="app">
   
    <router-view/>
     <MessageBoard />
  </div>
</template>

<script>
import MessageBoard from '@/components/MessageBoard.vue'
export default {
  name: 'App',
   components: {
    MessageBoard
  }
}
</script>

<style>
*{
    padding: 0;
  
  margin: 0;
}
#app {
  
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
 
}
</style>



// WEBPACK FOOTER //
// src/App.vue